module.exports = __webpack_public_path__ + "static/media/SCBpig.90a08c79.svg";